import { render, staticRenderFns } from "./PrintKwitansi.vue?vue&type=template&id=0cb0cd66&scoped=true"
import script from "./PrintKwitansi.vue?vue&type=script&lang=js"
export * from "./PrintKwitansi.vue?vue&type=script&lang=js"
import style0 from "./PrintKwitansi.vue?vue&type=style&index=0&id=0cb0cd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0cd66",
  null
  
)

export default component.exports